"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AraasRemoteAudioTrack = exports.AraasLocalAudioTrack = exports.ARaaSAudioTrack = void 0;
const toolbox_1 = require("@streem/toolbox");
const rxjs_1 = require("rxjs");
const logger_1 = require("../../util/logger");
const media_track_1 = require("./media_track");
class ARaaSAudioTrack extends media_track_1.MediaTrack {
    constructor(track) {
        super(track);
        this.track = track;
        this.audioLevelSubject = new rxjs_1.BehaviorSubject(0);
        this.audioLevel = this.audioLevelSubject.asObservable();
        (0, toolbox_1.pollAudioLevel)({
            track,
            onLevelChanged: (newLevel) => {
                this.audioLevelSubject.next(newLevel);
            },
            onError: (message, err) => logger_1.logger.error(message, err),
        });
    }
}
exports.ARaaSAudioTrack = ARaaSAudioTrack;
class AraasLocalAudioTrack extends ARaaSAudioTrack {
    constructor(track) {
        super(track);
        this.track = track;
    }
    restart(_) {
        return __awaiter(this, void 0, void 0, function* () {
            console.error('restart method not implemented yet');
            return Promise.resolve(false);
        });
    }
    setEnabled(enable) {
        // Track muting & unmuting is independent of the MediaStreamTrack's
        // mute && unmute events. This is why we emit an event
        // when the application toggles the MediaStream track's enabled state.
        // https://w3c.github.io/mediacapture-main/#track-muted
        this.track.enabled = enable;
        this.enabledSubject.next(enable);
    }
}
exports.AraasLocalAudioTrack = AraasLocalAudioTrack;
class AraasRemoteAudioTrack extends ARaaSAudioTrack {
    constructor(track) {
        super(track);
        this.track = track;
        this.logger = logger_1.logger.extend('sdk-araas:remote_audio_track');
        (0, toolbox_1.webkitAudioFix230902)(track);
        this.audioTrackSubject = new rxjs_1.BehaviorSubject(this.attach());
        this.audioTrack = this.audioTrackSubject.asObservable();
    }
    attach() {
        const audioElement = document.createElement('audio');
        audioElement.autoplay = true;
        const mediaStream = new MediaStream();
        mediaStream.addTrack(this.track);
        audioElement.srcObject = mediaStream;
        audioElement.play();
        return audioElement;
    }
    selectSpeaker(deviceId, userSid) {
        return __awaiter(this, void 0, void 0, function* () {
            this.audioTrack
                .pipe((0, rxjs_1.filter)(audioElement => audioElement !== undefined))
                .pipe((0, rxjs_1.take)(1))
                .subscribe({
                next: (audioElement) => {
                    // @ts-ignore
                    audioElement.setSinkId(deviceId).then(() => {
                        document.body.appendChild(audioElement);
                    });
                    this.logger.info(`selected Speaker for tracksource is ${deviceId} of Participant: ${userSid}`);
                },
            });
        });
    }
}
exports.AraasRemoteAudioTrack = AraasRemoteAudioTrack;
//# sourceMappingURL=audio_tracks.js.map